import * as React from "react";
import { useState, useEffect } from "react";
import { Page } from "../../components/Page";
import {
  deleteTaxList,
  getCurrentUser,
  getTaxList,
} from "../../api-config/config";
import SimpleTable from "../../components/table/SimpleTable";
// import TaxForm from "../../components/TaxForm";
import NewTaxForm from "../../components/TaxForm/newTaxForm";
import SnackBar from "../../components/SnackBar/SnackBar";
import LoaderWrapper from "../../components/LoaderWrapper/LoaderWrapper";

export default function NewTaxList() {
  const [taxList, setTaxList] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const loggedUser = getCurrentUser();

  const getTaxListData = (hotel_code: number) => {
    setLoading(true);
    return getTaxList(hotel_code).then(
      (res: any) => {
        if (res?.status_message === "success") {
          setTaxList(res.data);
        }
        setLoading(false);
      },
      (error: any) => {
        console.log("error", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getTaxListData(loggedUser?.hotel_code);
  }, []);

  function onTaxAdded() {
    getTaxListData(loggedUser?.hotel_code);
  }

  return (
    <Page title="Home">
      {loading && <LoaderWrapper />}
      <div style={{ padding: "0px 20px" }}>
        <TaxListGrid
          row={taxList}
          loggedUser={loggedUser}
          onTaxAdded={onTaxAdded}
          setLoading={setLoading}
        />
      </div>
    </Page>
  );
}

function TaxListGrid(data: any) {
  const [open, setOpen] = React.useState(false);
  const { row, onTaxAdded, setLoading } = data;

  const [snackbar, setSnackbar] = React.useState({
    visible: false,
    message: "",
    type: "success" as "success" | "error",
  });
  
  const showSnackbar = (message: string, type: "success" | "error") => {
    setSnackbar({ visible: true, message, type });
  };

  const handleDelete = async (row: any) => {
    if (!window.confirm(`Delete tax "${row.taxName}"?`)) return;

    try {
      setLoading(true);
      const res = await deleteTaxList(row.taxId);

      if (res?.status_message === "failed") {
        setLoading(false);
        showSnackbar(res.message || "Delete failed", "error");
        return;
      }

      showSnackbar("Tax deleted successfully", "success");
      onTaxAdded();
    } catch (err) {
      setLoading(false);
      showSnackbar("Something went wrong while deleting", "error");
    }
  };

  const rows: any[] = [];
  if (row) {
    row.forEach((item: any, index: number) => {
      rows.push({
        serial: index + 1,
        taxName: item.name,
        taxType: item.tax_type,
        minAmount: item.min_amount,
        maxAmount: item.max_amount,
        value: item.value,
        taxId: item.id,
      });
    });
  }

  const columns = [
    { header: "#", accessor: "serial", width: "5%" },
    { header: "Tax Name", accessor: "taxName", width: "20%" },
    { header: "Tax Type", accessor: "taxType", width: "15%" },
    { header: "Min Amount", accessor: "minAmount", width: "15%" },
    { header: "Max Amount", accessor: "maxAmount", width: "15%" },
    { header: "Value", accessor: "value", width: "10%" },
    {
      header: "Actions",
      accessor: "actions",
      align: "center" as const,
      render: (_: any, row: any) => (
        <span
          style={{ cursor: "pointer", color: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}
          onClick={() => handleDelete(row)}
          title="Delete"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 30 30" fill="none">
						<path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z" fill="red"/>
					</svg>
        </span>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div className="roomtype-header">
        <h2 className="roomtype-title">Tax List</h2>
        <div className="roomtype-btns">
          <button className="my-custom-btn" onClick={() => setOpen(true)}>
            Add Tax
          </button>
        </div>
      </div>

      <SimpleTable columns={columns} data={rows} />

      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Add Tax</h3>
            </div>

            <div className="modal-content">
              <NewTaxForm
                handleClose={() => setOpen(false)}
                onTaxAdded={onTaxAdded}
                showSnackbar={showSnackbar}
                setLoading={setLoading}
              />
            </div>
          </div>
        </div>
      )}

      <SnackBar
        visible={snackbar.visible}
        message={snackbar.message}
        type={snackbar.type}
        onClose={() => setSnackbar(prev => ({ ...prev, visible: false }))}
      />
    </div>
  );
}